import reduceReducer from "reduce-reducers"
import standardTechnologyReducer from "./standardTechnologyReducer"
import standardTemplateReducer from "./standardTemplateReducer"

export default reduceReducer(standardTechnologyReducer, standardTemplateReducer)
